import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminBubbleToast.css';

/**
 * Renders the transient admin bubbles from useAdminBubbles(). Bottom-left so it
 * never fights the help widget / announcement dock in the bottom-right.
 */
const AdminBubbleToast = ({ bubbles, onDismiss }) => {
    const navigate = useNavigate();
    if (!bubbles.length) return null;

    const act = (b) => {
        if (b.openDock) window.dispatchEvent(new CustomEvent('announcement:open-dock'));
        else if (b.target) navigate(b.target);
        onDismiss(b.id);
    };

    return (
        <div className="admin-bubble-stack" role="region" aria-label="Admin notifications">
            {bubbles.map((b) => (
                <div key={b.id} className={`admin-bubble admin-bubble--${b.kind}`} role="status">
                    <span className="admin-bubble__icon">{b.kind === 'bug' ? '🐞' : '📢'}</span>
                    <div className="admin-bubble__body" onClick={() => act(b)}>
                        <div className="admin-bubble__title">{b.title}</div>
                        <div className="admin-bubble__detail">{b.detail}</div>
                    </div>
                    <button type="button" className="admin-bubble__close" aria-label="Dismiss" onClick={() => onDismiss(b.id)}>
                        &times;
                    </button>
                </div>
            ))}
        </div>
    );
};

export default AdminBubbleToast;
